import React from 'react';
import { FC } from 'react';
import classes from './QueueList.module.scss';
import { AgentsTicketType } from '../../../../pagesMain/Agent1Page/Agent1Page';
import { format } from 'date-fns';
import { AgentStatus } from '../../../../types/enums';
import classNames from 'classnames';

type QueueListProps = {
  agentTickets: AgentsTicketType[] | [];
  activeTicket?: AgentsTicketType;
  setActiveTicket?: (data: AgentsTicketType) => void;
  agentStatus?: AgentStatus;
  benefitTicketColor?: string;
  otoTicketColor?: string;
};

const DEFAULT_BENEFIT_COLOR = '#cfe2ff';
const DEFAULT_OTO_COLOR = '#f8d7da';

const resolvePrivilegeKind = (item: AgentsTicketType): 'BENEFIT' | 'EMERGENCY' | null => {
  if (item.privilegeKind === 'EMERGENCY' || item.privilegeKind === 'BENEFIT') {
    return item.privilegeKind;
  }
  const priority = item.priority ?? 0;
  if (priority >= 20) {
    return 'EMERGENCY';
  }
  if (priority > 0) {
    return 'BENEFIT';
  }
  return null;
};

export const QueueList: FC<QueueListProps> = ({
  agentTickets,
  setActiveTicket,
  activeTicket,
  agentStatus,
  benefitTicketColor = DEFAULT_BENEFIT_COLOR,
  otoTicketColor = DEFAULT_OTO_COLOR
}) => {
  return (
    <div className={classes.container}>
      {agentTickets &&
        agentTickets.map((item: AgentsTicketType) => {
          const privilegeKind = resolvePrivilegeKind(item);
          const highlightColor =
            privilegeKind === 'EMERGENCY'
              ? otoTicketColor
              : privilegeKind === 'BENEFIT'
                ? benefitTicketColor
                : undefined;

          return (
            <div
              key={item.id}
              className={classNames(classes.row, {
                [classes.activeTicket]: activeTicket && activeTicket.id === item.id,
                [classes.hover]: setActiveTicket
              })}
              style={highlightColor ? { backgroundColor: highlightColor } : undefined}
              onClick={
                setActiveTicket && agentStatus === AgentStatus.Waiting
                  ? () => setActiveTicket(item)
                  : undefined
              }>
              <div className={classes.rowTicket}>{item.name}</div>
              <div className={classes.rowTime}>{format(item.dateTime, 'HH:mm')}</div>
              <div className={classes.rowServiceName}>{item.topicName}</div>
              <div className={classes.bottomLine}></div>
              {!item.status && <div className={classes.crossOutLine}></div>}
            </div>
          );
        })}
    </div>
  );
};
export default QueueList;
